// ============================================================================
// Disposition
// ============================================================================

export enum InmarDisposition {
  WIP = "WIP",
  DONATE = "DONATE",
  // cspell:disable-next-line
  DESTROY_ON = "DESTROYON",
  LIQUIDATE = "LIQUIDATE",
  RTV = "RTV",
  HOLD = "HOLD",
  DESTROY_OFF = "DESTROYOFF",
  // cspell:disable-next-line
  RTNCLN = "RTNCLN",
  DESTROY_IN_FIELD = "DESTROYINFIELD",
  // cspell:disable-next-line
  RTNCLNHAZ = "RTNCLNHAZ",
  RTS = "RTS",
}

export const InmarDispositionDisplayText = {
  [InmarDisposition.WIP]: "Work in Progress",
  [InmarDisposition.DONATE]: "Donation or 2nd Quality Item",
  [InmarDisposition.DESTROY_ON]: "Destroy at Facility",
  // cspell:disable-next-line
  [InmarDisposition.LIQUIDATE]: "Remarketing Market",
  [InmarDisposition.RTV]: "Return to Vendor",
  [InmarDisposition.HOLD]: "Hold for Inventory",
  [InmarDisposition.DESTROY_OFF]: "Destroy at Destruction Facility (HAZ)",
  // cspell:disable-next-line
  [InmarDisposition.RTNCLN]: "Return to Client",
  [InmarDisposition.DESTROY_IN_FIELD]: "Destroy in Field",
  // cspell:disable-next-line
  [InmarDisposition.RTNCLNHAZ]: "Return Hazardous Item to Client",
  [InmarDisposition.RTS]: "Return to Stock",
} as const;

// ============================================================================
// Disposition Action
// ============================================================================

export enum InmarDispositionAction {
  APPROVAL = "approval",
  REJECT = "reject",
  NOTHING = "nothing",
}

export const InmarDispositionActionDisplayText = {
  [InmarDispositionAction.APPROVAL]: "Approval",
  [InmarDispositionAction.REJECT]: "Reject",
  [InmarDispositionAction.NOTHING]: "No Action",
} as const;

export interface InmarCapturedResponseConfig {
  name: string;
  value: string;
  action: InmarDispositionAction;
  restock: boolean;
}

export interface InmarDispositionMapping {
  disposition: InmarDisposition;
  capturedResponses: InmarCapturedResponseConfig[];
  defaultAction: InmarDispositionAction;
  defaultRestock: boolean;
}

// ============================================================================
// Issue Code
// ============================================================================

export enum InmarIssueCode {
  NOT_HEADED_TO_INMAR = "not-headed-to-inmar",
  MISSING_IDS = "missing-ids",
  PENDING_MANUAL_REVIEW = "pending-manual-review",
  NO_SHIPMENTS_PRESENT = "no-shipments-present",
  INTERNAL_ERROR = "internal-error",
  SUCCESS = "success",
}

export const inmarIssueCodeToDisplayText: Record<InmarIssueCode, string> = {
  [InmarIssueCode.NOT_HEADED_TO_INMAR]: "not headed to Inmar",
  [InmarIssueCode.MISSING_IDS]: "missing IDs",
  [InmarIssueCode.PENDING_MANUAL_REVIEW]: "pending manual review",
  [InmarIssueCode.NO_SHIPMENTS_PRESENT]: "no shipments present",
  [InmarIssueCode.INTERNAL_ERROR]: "internal error",
  [InmarIssueCode.SUCCESS]: "success",
};

export const INMAR_DATADOG_METRIC = "redo.return.inmar.createRma";

export enum InmarMetricTags {
  OUTCOME = "redo.return.inmar.outcome",
  NUM_ITEMS_ADDED = "redo.return.inmar.numItemsAdded",
}

// ============================================================================
// Item ID Resolution
// ============================================================================

export enum InmarItemIdResolutionSource {
  SKU = "sku",
  UPC_BARCODE = "upc",
  MANUAL = "manual",
}

export const idResolutionSourceToDisplayText: Record<
  InmarItemIdResolutionSource,
  string
> = {
  [InmarItemIdResolutionSource.SKU]: "SKU",
  [InmarItemIdResolutionSource.UPC_BARCODE]: "UPC Barcode",
  [InmarItemIdResolutionSource.MANUAL]: "Manual",
};
